const BOOLEAN_VALUES = ['decommissioned'];

export default BOOLEAN_VALUES;
